export default "__VITE_ASSET__COVzSql$__"